/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SaPayslipSection } from '../model/saPayslipSection';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SaPayslipSectionService {

    protected basePath = 'https://gateway.dev.meu-solutions.com/staginganawork';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param sheetId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsGet(sheetId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsGet(sheetId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsGet(sheetId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsGet(sheetId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetId === null || sheetId === undefined) {
            throw new Error('Required parameter sheetId was null or undefined when calling apiSalariesSaSheetsSheetIdSaPayslipSectionsGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/salaries/saSheets/${encodeURIComponent(String(sheetId))}/saPayslipSections`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdDelete(sheetId: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdDelete(sheetId: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdDelete(sheetId: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdDelete(sheetId: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetId === null || sheetId === undefined) {
            throw new Error('Required parameter sheetId was null or undefined when calling apiSalariesSaSheetsSheetIdSaPayslipSectionsIdDelete.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSalariesSaSheetsSheetIdSaPayslipSectionsIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/salaries/saSheets/${encodeURIComponent(String(sheetId))}/saPayslipSections/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdGet(sheetId: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdGet(sheetId: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdGet(sheetId: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdGet(sheetId: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetId === null || sheetId === undefined) {
            throw new Error('Required parameter sheetId was null or undefined when calling apiSalariesSaSheetsSheetIdSaPayslipSectionsIdGet.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSalariesSaSheetsSheetIdSaPayslipSectionsIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/salaries/saSheets/${encodeURIComponent(String(sheetId))}/saPayslipSections/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetId 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdPut(sheetId: string, id: string, body?: SaPayslipSection, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdPut(sheetId: string, id: string, body?: SaPayslipSection, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdPut(sheetId: string, id: string, body?: SaPayslipSection, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsIdPut(sheetId: string, id: string, body?: SaPayslipSection, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetId === null || sheetId === undefined) {
            throw new Error('Required parameter sheetId was null or undefined when calling apiSalariesSaSheetsSheetIdSaPayslipSectionsIdPut.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSalariesSaSheetsSheetIdSaPayslipSectionsIdPut.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/api/salaries/saSheets/${encodeURIComponent(String(sheetId))}/saPayslipSections/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sheetId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsPost(sheetId: string, body?: SaPayslipSection, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsPost(sheetId: string, body?: SaPayslipSection, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsPost(sheetId: string, body?: SaPayslipSection, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiSalariesSaSheetsSheetIdSaPayslipSectionsPost(sheetId: string, body?: SaPayslipSection, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sheetId === null || sheetId === undefined) {
            throw new Error('Required parameter sheetId was null or undefined when calling apiSalariesSaSheetsSheetIdSaPayslipSectionsPost.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/salaries/saSheets/${encodeURIComponent(String(sheetId))}/saPayslipSections`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
